import React from 'react'
import FormControlLabel from '@mui/material/FormControlLabel'
import Switch from '@mui/material/Switch'
import FormHelperText from '@mui/material/FormHelperText'
import Box from '@mui/material/Box'

/**
 * Reusable Switch component with consistent styling
 *
 * @param {string} label - Switch label
 * @param {boolean} checked - Whether the switch is on
 * @param {function} onChange - Change handler (receives boolean value)
 * @param {string} name - Optional name attribute
 * @param {boolean} disabled - Whether the switch is disabled
 * @param {string} helperText - Helper text to display below
 * @param {string} labelPlacement - Label placement: 'end' | 'start' | 'top' | 'bottom'
 * @param {string} color - Switch color: 'primary' | 'secondary' | etc
 * @param {object} sx - Additional MUI sx styles
 */
const SwitchField = ({
    label,
    checked = false,
    onChange,
    name,
    disabled = false,
    helperText = '',
    labelPlacement = 'end',
    color = 'primary',
    sx = {},
    ...props
}) => {
    const handleChange = (event) => {
        if (onChange) {
            onChange(event.target.checked, event)
        }
    }

    return (
        <Box sx={sx}>
            <FormControlLabel
                control={
                    <Switch
                        checked={Boolean(checked)}
                        onChange={handleChange}
                        name={name}
                        color={color}
                        disabled={disabled}
                        size="small"
                        {...props}
                    />
                }
                label={label}
                labelPlacement={labelPlacement}
            />
            {helperText && (
                <FormHelperText sx={{ ml: 2, mt: -0.5 }}>
                    {helperText}
                </FormHelperText>
            )}
        </Box>
    )
}

export default SwitchField
